import React, { useState, useEffect } from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKPagination from "components/MKPagination"; // Importar MKPagination
import Icon from "@mui/material/Icon";
import Autocomplete from "@mui/material/Autocomplete";
import MKInput from "components/MKInput";
import coursesData from "pages/academy/data/courses.json";
import SimpleBookingCard from "custom/Cards/BookingCards/SimpleBookingCard";

function Search() {
  const [filteredCourses, setFilteredCourses] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState({
    duration: "",
    level: "",
    title: ""
  });
  const coursesPerPage = 6;

  useEffect(() => {
    // Calcular la longitud máxima de las descripciones
    const maxLength = Math.max(...coursesData.map(course => course.description.length));

    // Rellenar las descripciones para que coincidan con la longitud máxima usando espacios Unicode
    const paddedCourses = coursesData.map(course => {
      const paddingLength = maxLength - course.description.length;
      const paddedDescription = course.description + '\u00A0'.repeat(paddingLength);
      return {
        ...course,
        description: paddedDescription
      };
    });

    // Ordenar los cursos para que los cursos disponibles aparezcan primero
    const sortedCourses = paddedCourses.sort((a, b) => b.available - a.available);

    setFilteredCourses(sortedCourses);
  }, []);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleFilterChange = (name) => (event, value) => {
    setFilters({
      ...filters,
      [name]: value
    });
    setCurrentPage(1); // Restablecer a la página 1 al cambiar el filtro
  };

  const filteredAndSortedCourses = filteredCourses.filter(course => {
    return (
      (filters.duration === "" || course.duration.includes(filters.duration)) &&
      (filters.level === "" || course.level.includes(filters.level)) &&
      (filters.title === "" || course.title.toLowerCase().includes(filters.title.toLowerCase()))
    );
  });

  const indexOfLastCourse = currentPage * coursesPerPage;
  const indexOfFirstCourse = indexOfLastCourse - coursesPerPage;
  const currentCourses = filteredAndSortedCourses.slice(indexOfFirstCourse, indexOfLastCourse);

  const filteredOptions = {
    titles: [...new Set(coursesData.map(course => course.title))],
    durations: [...new Set(coursesData.map(course => course.duration))],
    levels: [...new Set(coursesData.map(course => course.level))]
  };

  return (
    <MKBox component="section">
      <Container>
        <Grid container spacing={{ xs: 0, lg: 3 }} sx={{ pt: 2, pb: 3, px: 2, mx: "auto" }}>
          <Grid item xs={12} lg={4} sx={{ mt: 2 }}>
            <MKTypography display="block" variant="button" fontWeight="regular" color="text" mb={1}>
              Título
            </MKTypography>
            <Autocomplete
              options={filteredOptions.titles}
              value={filters.title}
              onChange={handleFilterChange("title")}
              renderInput={(params) => <MKInput {...params} variant="standard" placeholder="Selecciona un título" />}
            />
          </Grid>
          <Grid item xs={12} lg={4} sx={{ mt: 2 }}>
            <MKTypography display="block" variant="button" fontWeight="regular" color="text" mb={1}>
              Duración
            </MKTypography>
            <Autocomplete
              options={filteredOptions.durations}
              value={filters.duration}
              onChange={handleFilterChange("duration")}
              renderInput={(params) => <MKInput {...params} variant="standard" placeholder="Selecciona una duración" />}
            />
          </Grid>
          <Grid item xs={12} lg={4} sx={{ mt: 2 }}>
            <MKTypography display="block" variant="button" fontWeight="regular" color="text" mb={1}>
              Nivel
            </MKTypography>
            <Autocomplete
              options={filteredOptions.levels}
              value={filters.level}
              onChange={handleFilterChange("level")}
              renderInput={(params) => <MKInput {...params} variant="standard" placeholder="Selecciona un nivel" />}
            />
          </Grid>
        </Grid>
        <Grid container spacing={3} sx={{ mt: 3 }}>
          {currentCourses.map((course, index) => (
            <Grid item xs={12} md={6} lg={4} key={index}>
              <MKBox mt={3} sx={{ height: '100%' }}>
                <SimpleBookingCard
                  title={course.title}
                  description={course.description}
                  categories={[`${course.location} - ${course.duration}`, course.level]}
                  action={{
                    type: "internal",
                    route: course.route,
                    color: "info",
                    label: "Contáctanos",
                  }}
                  available={course.available}
                />
              </MKBox>
            </Grid>
          ))}
        </Grid>
        <MKBox mt={5} sx={{ display: 'flex', justifyContent: 'center' }}>
          <MKPagination>
            <MKPagination item onClick={(e) => handlePageChange(e, currentPage - 1)} disabled={currentPage === 1}>
              <Icon>keyboard_arrow_left</Icon>
            </MKPagination>
            {Array.from({ length: Math.ceil(filteredAndSortedCourses.length / coursesPerPage) }, (_, index) => (
              <MKPagination item key={index + 1} active={index + 1 === currentPage} onClick={(e) => handlePageChange(e, index + 1)}>
                {index + 1}
              </MKPagination>
            ))}
            <MKPagination item onClick={(e) => handlePageChange(e, currentPage + 1)} disabled={currentPage === Math.ceil(filteredAndSortedCourses.length / coursesPerPage)}>
              <Icon>keyboard_arrow_right</Icon>
            </MKPagination>
          </MKPagination>
        </MKBox>
      </Container>
    </MKBox>
  );
}

export default Search;